(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-bar"] && !Shopify.designMode) return;
  try {
    
  class BenefitsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.benefits-bar__inner');
      if (!this.track) return;

      this.timer = null;
      this.mediaQuery = window.matchMedia('(max-width: 767px)');

      this.track.addEventListener('touchstart', () => this.stop());
      this.track.addEventListener('touchend', () => this.start());
      this.mediaQuery.addEventListener('change', () => this.toggle());

      this.toggle();
    }

    disconnectedCallback() {
      this.stop();
    }

    toggle() {
      if (this.mediaQuery.matches) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.timer || !this.mediaQuery.matches) return;
      this.timer = setInterval(() => this.scrollToNext(), 2000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    scrollToNext() {
      const items = this.track.querySelectorAll('.benefit-item');
      if (!items.length) return;

      const gap = 12;
      const step = items[0].getBoundingClientRect().width + gap;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const nextLeft = this.track.scrollLeft + step;

      this.track.scrollTo({
        left: nextLeft >= maxScroll - 5 ? 0 : nextLeft,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('benefits-carousel', BenefitsCarousel);

  } catch(e) { console.error(e); }
})();
})();
